module.exports = __webpack_public_path__ + "e1aec03768be765dc9ac3edaf2e88680.svg";